export default __webpack_public_path__ + "static/media/FoodVillaa.1719efba.JPG";